import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { TipuriDocumenteService } from '../tipuri-documente.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { TipuriDocumente } from '../tipuri-documente.interface';
import { finalize, Observable } from 'rxjs';
import { CategoriiDocumenteService } from '../../categorii-documente/categorii-documente.service';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-add-tipuri-documente',
    templateUrl: './add-tipuri-documente.component.html',
    styleUrls: ['./add-tipuri-documente.component.scss']
})
export class AddTipuriDocumenteComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        id_group: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
        observations: new FormControl(''),
    });

    categoriiDocumente$!: Observable<Generic[]>;

    constructor(
        private dialogRef: MatDialogRef<AddTipuriDocumenteComponent>,
        private tipuriDocumenteService: TipuriDocumenteService,
        private notificationService: NotificationService,
        private authService: AuthService,
        private categoriiDocumenteService: CategoriiDocumenteService,
    ) {
        this.processToken();
    }

    ngOnInit() {
        this.loadCategorii();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.tipuriDocumenteService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, id_group, slug, observations } = this.form
            .value as TipuriDocumente;
        const newCategorie: TipuriDocumente = {
            name,
            id_group,
            slug,
            observations,
        };

        this.tipuriDocumenteService
            .addTip(newCategorie)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }

    loadCategorii() {
        this.isLoading = true;
        this.categoriiDocumente$ = this.categoriiDocumenteService
            .getCategoriiDocumenteActive()
            .pipe(finalize(() => (this.isLoading = false)));
    }
}
